require('./angular');
module.exports = angular;



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular/index.js
 ** module id = 2
 ** module chunks = 0
 **/